import { memo, useCallback, useId, useMemo } from "react"

import Checkbox from "components/Checkbox/Checkbox"
import { cn } from "components/lib/utils"

import { CheckbokItemProps } from "./types"

export const CheckbokItem = memo(({ item, selectedItems, onChange, dataTestId }: CheckbokItemProps) => {
    const uniqueId = useId()
    const isSelected = useMemo(() => selectedItems.includes(item.value), [selectedItems, item.value])

    const handleChange = useCallback(() => {
        onChange(item.value)
    }, [onChange, item.value])

    const checkboxTestId = useMemo(() => {
        if (!dataTestId) return undefined
        return `${dataTestId}-${item.value}`
    }, [dataTestId, item.value])

    return (
        <div
            className={cn(
                'flex items-center gap-2 rounded-md px-2 py-1.5 transition-colors [&_label]:font-normal',
                isSelected ? 'bg-neutral-100' : 'hover:bg-base-muted'
            )}
        >
            <Checkbox
                id={uniqueId}
                className="[&[data-state=checked]]:bg-indigo-500 [&[data-state=indeterminate]]:bg-indigo-500"
                label={item.label}
                value={item.value}
                checked={isSelected}
                onCheckedChange={handleChange}
                dataTestId={checkboxTestId}
            />
        </div>
    )
})